import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';
import Faces from '../../../shared/library/cards/faces';
import {ComponentContainer, Spinner, StyledSmallTitle, Center} from './shared/styles';
import {compose, Query} from 'react-apollo';
import {followers} from '../../../data/tool-profile/queries';
import {MobileContext} from '../../../shared/enhancers/mobile-enhancer';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import {flattenEdges} from '../../../shared/utils/graphql';
import {updateQuery} from '../utils';
import DescriptionCard from '../../../shared/library/cards/description';
import NavAnchor, {NAV_ANCHOR_OFFSET} from './shared/nav-anchor';
import glamorous from 'glamorous';
import SignUp from '../../../shared/library/buttons/sign-up';
import {withAnalyticsPayload} from '../../../shared/enhancers/analytics-enhancer';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const FOLLOWERS = 'followers';

const Container = glamorous.div({
  margin: '25px 0'
});

const Followers = ({tool, currentUser}) => {
  const isMobile = useContext(MobileContext);
  return (
    <ComponentContainer>
      <NavAnchor id="followers" offset={NAV_ANCHOR_OFFSET} />
      <Query
        query={followers}
        variables={{id: tool.id, first: isMobile ? 8 : 10}}
        notifyOnNetworkStatusChange={true}
      >
        {({loading, data, fetchMore}) => {
          const hasData = data && data.tool;
          if (loading && !hasData)
            return (
              <Spinner>
                <Circular size={LARGE} />
              </Spinner>
            );

          if (hasData) {
            const followers = flattenEdges(data.tool.followers);
            const followersCount = data.tool.followers.count;
            const endCursor = data.tool.followers.pageInfo.endCursor;
            const hasNextPage = data.tool.followers.pageInfo.hasNextPage;

            const onLoadMoreClick = () => {
              fetchMore({
                variables: {
                  after: endCursor,
                  first: isMobile ? 16 : 20
                },
                updateQuery
              });
            };

            return (
              <Fragment>
                <DescriptionCard>
                  <StyledSmallTitle>{tool.name}&#39;s Followers</StyledSmallTitle>
                  <Fragment>
                    <strong>{followersCount}</strong> developers follow <strong>{tool.name}</strong>{' '}
                    to keep up with related blogs and decisions.
                  </Fragment>
                </DescriptionCard>
                <Container>
                  <Faces
                    isMobile={isMobile}
                    users={followers}
                    hasNextPage={currentUser && hasNextPage}
                    loadMore={onLoadMoreClick}
                    loading={loading}
                  />
                </Container>
                <Center>
                  {!currentUser && hasNextPage && (
                    <SignUp text="Sign up to see more" section={FOLLOWERS} />
                  )}
                </Center>
              </Fragment>
            );
          }
        }}
      </Query>
    </ComponentContainer>
  );
};

Followers.propTypes = {
  tool: PropTypes.object,
  currentUser: PropTypes.object
};

export default compose(
  withAnalyticsPayload(),
  withErrorBoundary(true)
)(Followers);
